/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-destructuring, one-var */

import { Component } from 'react';
import Can from '../common/guards/can';


import SideMenuItem from './menu-item';
import SideMenuDropdown from './menu-dropdown';
import { isPseudoLoggedIn } from '../../utils/tokenUtils';

import {navBarLinks, navBarLinksAdmin, navBarLinksReps, navBarLinksPreLogin} from '../../data/navbarLinks';

import './sidenav.css';
import {USER_TYPE_ADMIN, USER_TYPE_REP, USER_TYPE_RETAILER, USER_TYPE_PRE_LOGIN} from '../../data/userTypes';

class SideNav extends Component {
  getOpenedMenu = () => localStorage.getItem('navbarToggles') || '';
  toggleMenu = (key) => {
    const currentKey = localStorage.getItem('navbarToggles');
    if (currentKey === key) {
      localStorage.setItem('navbarToggles', '');
      this.setState({openedMenu: ''});
    } else {
      localStorage.setItem('navbarToggles', key);
      this.setState({openedMenu: key});
    }
  };

  constructor(props) {
    super(props);

    this.state = {
      scrollTop: 0,
      openedMenu: this.getOpenedMenu()
    };
  }

  render() {
    const {type, menuOpened} = this.props;
    const pseudo = isPseudoLoggedIn();

    const linkGroups = {
      [USER_TYPE_ADMIN]: navBarLinksAdmin,
      [USER_TYPE_RETAILER]: navBarLinks,
      [USER_TYPE_REP]: navBarLinksReps,
      [USER_TYPE_PRE_LOGIN]: navBarLinksPreLogin,
    };

    const links = linkGroups[type];

    return (
      <div className={menuOpened ? 'navbar-collapse collapse show' : 'navbar-collapse collapse'}>
        <ul className="sidebar-nav" id="sidebar-nav">
          {links.map((item, index) => {
            let action = true,
              subjectClass = '';
            if (item.permissions) {
              action = item.permissions.action;
              subjectClass = item.permissions.subjectClass;
            }
            if (item.hasOwnProperty('children')) {
              const key = `dd_${index}`;
              return (
                <Can action={action} key={key} subjectClass={subjectClass}>
                  <SideMenuDropdown
                    className="nav-item"
                    handleOpen={this.toggleMenu}
                    open={this.state.openedMenu === key}
                    title={item.title}
                    toggleKey={key}
                  >
                    {item.children.map((child, childKey) => {
                      let childAction = true;
                      let childSubjectClass = '';
                      if (child.permissions) {
                        childAction = child.permissions.action;
                        childSubjectClass = child.permissions.subjectClass;
                      }

                      const show = !(child.hidePseudo && pseudo);

                      return (
                        <Can action={childAction} key={`sidenav_${childKey}`} subjectClass={childSubjectClass}>
                          {show && <SideMenuItem href={child.href} id={`sidenav_${childKey}`} title={child.title}/>}
                        </Can>
                      );
                    })}
                  </SideMenuDropdown>
                </Can>
              );
            }
            return (
              <Can action={action} key={`sidenav_${index}`} subjectClass={subjectClass}>
                <SideMenuItem handleOpen={this.toggleMenu} href={item.href} id={`sidenav_${index}`} title={item.title}/>
              </Can>
            );
          })}
        </ul>
      </div>
    );
  }
}


export default SideNav;
